<template>
  <!-- Modal -->
  <div
    class="modal fade"
    ref="vuemodal"
    id="ShippingDownloadFilesModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-md">
      <div class="modal-content">
        <vue-element-loading
          :active="isSearching"
          spinner="bar-fade-scale"
          color="#333"
        />
        <div class="modal-header">
          <h5 class="modal-title font-weight-bold">{{ translations('shipping_instruction.files') }}</h5>
          <button type="button" class="close" data-dismiss="modal">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="form-group col-md-6">
              <span class="text-nowrap mr-1">{{ translations('shipping_instruction.warehouse_selection') }}</span>
              <select @change='(e) => this.onChangeWareHouse(e)' class="form-control">
                <option :selected="selectWarehouseId === item.id" :value="item.id" v-for='(item, i) in warehouses' :key='i'>{{ item.name }}</option>
              </select>
            </div>

            <div class="form-group d-flex align-items-center flex-wrap col-md-6">
              <span class="text-nowrap mr-1">{{ translations('sale.ship_date') }}</span>
              <input @change='(e) => this.onChangeDate(e)' type="date" class="form-control" :value="currentSearch.date" >
            </div>
          </div>

          <v-data-table
            class="table table-striped"
            item-key="name"
            :headers="[
              { text: this.translations('shipping_instruction.file_name'), value: 'name', sortable: false },
              { text: this.translations('shipping_instruction.update_date'), value: 'date', sortable: false },
              { text: '', value: 'status', sortable: false }
              ]"
            :items="files"
            :options.sync="options"
            hide-default-footer
            @page-count="pageCount = $event"
          >
            <template v-slot:body="{ items }">
              <tbody class="nowrap">
                <tr v-show="!items.length">
                  <td>{{ translations('shipping_instruction.message_information') }}</td>
                  <td></td>
                  <td></td>
                </tr>
                <tr v-for="(file, i) in items" :key="i" :class="{'d-none': !file.filename && !file.message}">
                  <td ><span v-bind:title="file.filename || file.message" class="fileName">{{ file.filename || file.message }}</span></td>
                  <td>{{ file.upload_date }}</td>
                  <td>
                    <button
                      v-if="file.filename"
                      class="btn btn-link btn-sm decoration-underline"
                      type="button"
                      @click="downloadFile(file.filepath)"
                    >
                      {{ translations('shipping_instruction.download') }}
                    </button>
                  </td>
                </tr>
              </tbody>
            </template>
          </v-data-table>
        </div>
        <div class="modal-footer d-flex justify-content-between">
          <button
            ref="closeModal"
            type="button"
            class="btn btn-secondary"
            data-dismiss="modal"
          >
            {{ translations('common.close') }}
          </button>
          <v-pagination
            v-model="options.page"
            :length="pageCount"
            :total-visible="4"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import { mapState } from 'vuex'

export default {
  name: 'ShippingDownloadFilesModal',
  components: {
    VueElementLoading
  },
  props: {
    warehouses: {
      type: Array
    },
    selectWarehouseId: {
      type: Number,
      default: 0
    },
    shippingDate: {
      type: String
    }
  },
  created () {
    this.getDownloadFiles(true)
  },
  mounted () {
    window.$(this.$refs.vuemodal).on('shown.bs.modal', this.getDownloadFiles)
  },
  data () {
    return {
      isSearching: false,
      files: [],
      page: 1,
      pageCount: 0,
      totalCount: 0,
      totalAmount: 0,
      options: {
        page: 1,
        itemsPerPage: 10
      },
      currentSearch: {
        date: this.shippingDate,
        warehouseId: this.warehouses
      }
    }
  },
  computed: {
    ...mapState(['currentLanguage'])
  },
  methods: {
    translations (key) {
      const language = require(`@/locales/${this.currentLanguage}.json`)
      const keys = key.split('.')
      let value = language

      for (const k of keys) {
        value = value[k]
        if (!value) break
      }

      return value || key
    },
    async getDownloadFiles (init) {
      let initUrl = null
      if (init) {
        this.currentSearch.date = this.shippingDate
        this.currentSearch.warehouseId = this.selectWarehouseId
        initUrl = `${this.$api_url.download_list}?shippingDate=${this.shippingDate}&&selectWarehouseId=${this.selectWarehouseId}`
      } else {
        initUrl = `${this.$api_url.download_list}?shippingDate=${this.currentSearch.date}&&selectWarehouseId=${this.currentSearch.warehouseId}`
      }
      this.isSearching = true
      try {
        const {
          data: { status, data }
        } = await this.$http.get(initUrl)
        if (status) {
          this.files = data
        } else {
          throw new Error('Something went wrong.')
        }
      } catch (error) {}
      this.isSearching = false
    },
    onChangeDate (e) {
      let date = e.target.value
      this.currentSearch.date = date
      this.getDownloadFiles(false)
    },
    onChangeWareHouse (e) {
      let warehouseId = e.target.value
      this.currentSearch.warehouseId = warehouseId
      this.getDownloadFiles(false)
    },
    async downloadFile (fileName) {
      this.isSearching = true
      try {
        window.open(this.$api_url.download_file + '?file=' + fileName)
      } catch (error) {}
      this.isSearching = false
    }
  }
}
</script>

<style scoped>
.fileName {
  width: 210px;
  display: block;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
